// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Elevator/escalator manufacturer.
 */
export class Vendor implements flatbuffers.IUnpackableObject<VendorT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Vendor {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsVendor(bb: flatbuffers.ByteBuffer, obj?: Vendor): Vendor {
    return (obj || new Vendor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsVendor(bb: flatbuffers.ByteBuffer, obj?: Vendor): Vendor {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Vendor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startVendor(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, deletedAtOffset, 0);
  }

  static endVendor(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createVendor(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Vendor.startVendor(builder);
    Vendor.addId(builder, idOffset);
    Vendor.addName(builder, nameOffset);
    Vendor.addCreatedAt(builder, createdAtOffset);
    Vendor.addUpdatedAt(builder, updatedAtOffset);
    Vendor.addDeletedAt(builder, deletedAtOffset);
    return Vendor.endVendor(builder);
  }

  unpack(): VendorT {
    return new VendorT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: VendorT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): VendorT {
    const t = new VendorT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class VendorT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    return Vendor.createVendor(builder, id, name, createdAt, updatedAt, deletedAt);
  }

  clone(): VendorT {
    const obj = new VendorT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: VendorT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyVendor(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
